const OPTION_KEY = 'espolon-short-labels-v1';
const ALT_KEY = 'espolon-alt-labels-v1';

type Map = Record<string, string>;

function read(key: string): Map {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as Map) : {};
  } catch {
    return {};
  }
}

function write(key: string, map: Map): void {
  try {
    localStorage.setItem(key, JSON.stringify(map));
  } catch {
    /* quota or private mode — silent */
  }
}

export function loadOptionShortLabels(): Map {
  return read(OPTION_KEY);
}

export function loadAltShortLabels(): Map {
  return read(ALT_KEY);
}

export function optionShortKey(qid: string, optIdx: number): string {
  return `${qid}:${optIdx}`;
}

export function altShortKey(
  qid: string,
  optIdx: number,
  promptIdx: number,
  altIdx: number,
): string {
  return `${qid}:${optIdx}:${promptIdx}:${altIdx}`;
}

export function saveOptionShortLabel(qid: string, optIdx: number, value: string): void {
  const map = read(OPTION_KEY);
  const key = optionShortKey(qid, optIdx);
  if (value) map[key] = value;
  else delete map[key];
  write(OPTION_KEY, map);
}

export function saveAltShortLabel(
  qid: string,
  optIdx: number,
  promptIdx: number,
  altIdx: number,
  value: string,
): void {
  const map = read(ALT_KEY);
  const key = altShortKey(qid, optIdx, promptIdx, altIdx);
  if (value) map[key] = value;
  else delete map[key];
  write(ALT_KEY, map);
}
